import React, { useEffect, useState } from 'react';
import axios from 'axios';

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });
const errorMessage = (error, fallback) => {
  const message = error.response?.data?.message || fallback;
  return Array.isArray(message) ? message.join(', ') : message;
};

export default function ContentSettings() {
  const [editors, setEditors] = useState([]);
  const [technologies, setTechnologies] = useState([]);
  const [editor, setEditor] = useState({ name: '', facebookLink: '', instagramLink: '', linkedinLink: '', image: null });
  const [technology, setTechnology] = useState({ name: '', type: 'Développement Web', category: 'Frontend' });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const load = async () => {
    try {
      const [editorResponse, technologyResponse] = await Promise.all([
        axios.get('/editor'),
        axios.get('/technology'),
      ]);
      setEditors(editorResponse.data);
      setTechnologies(technologyResponse.data);
    } catch (requestError) {
      setError(errorMessage(requestError, 'Impossible de charger la configuration.'));
    }
  };

  useEffect(() => { load(); }, []);

  const createEditor = async (event) => {
    event.preventDefault();
    setError('');
    const data = new FormData();
    data.append('name', editor.name);
    ['facebookLink', 'instagramLink', 'linkedinLink'].forEach((field) => {
      if (editor[field].trim()) data.append(field, editor[field].trim());
    });
    if (editor.image) data.append('imageUrl', editor.image);
    try {
      await axios.post('/editor', data, { headers: authHeaders() });
      setEditor({ name: '', facebookLink: '', instagramLink: '', linkedinLink: '', image: null });
      setMessage('Éditeur ajouté.');
      await load();
    } catch (requestError) {
      setError(errorMessage(requestError, 'Impossible d’ajouter l’éditeur.'));
    }
  };

  const createTechnology = async (event) => {
    event.preventDefault();
    setError('');
    try {
      await axios.post('/technology', technology, { headers: authHeaders() });
      setTechnology({ name: '', type: 'Développement Web', category: 'Frontend' });
      setMessage('Technologie ajoutée.');
      await load();
    } catch (requestError) {
      setError(errorMessage(requestError, 'Impossible d’ajouter la technologie.'));
    }
  };

  const remove = async (resource, id) => {
    if (!window.confirm('Supprimer cet élément ?')) return;
    try {
      await axios.delete(`/${resource}/${id}`, { headers: authHeaders() });
      setMessage('Élément supprimé.');
      await load();
    } catch (requestError) {
      setError(errorMessage(requestError, 'Suppression impossible. Cet élément est peut-être déjà utilisé.'));
    }
  };

  return (
    <div className="dashboard-container">
      <div className="top-bar"><h3>Configuration du contenu</h3></div>
      <p>Ajoutez ici les auteurs d’articles et les technologies proposées dans les formulaires de projet.</p>
      {message && <p style={{ color: 'green' }}>{message}</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <div className="form-card" style={{ marginBottom: 30 }}>
        <form onSubmit={createEditor} className="project-form">
          <h3>Nouvel éditeur d’article</h3>
          <div className="form-group"><label className="form-label">Nom *</label><input className="form-input" value={editor.name} onChange={(e) => setEditor({ ...editor, name: e.target.value })} required /></div>
          <div className="form-group"><label className="form-label">Photo (facultative, 8 Mo max.)</label><input className="form-input" type="file" accept="image/png,image/jpeg,image/svg+xml" onChange={(e) => setEditor({ ...editor, image: e.target.files?.[0] || null })} /></div>
          <div className="form-group"><label className="form-label">Facebook (facultatif)</label><input className="form-input" type="url" value={editor.facebookLink} onChange={(e) => setEditor({ ...editor, facebookLink: e.target.value })} /></div>
          <div className="form-group"><label className="form-label">Instagram (facultatif)</label><input className="form-input" type="url" value={editor.instagramLink} onChange={(e) => setEditor({ ...editor, instagramLink: e.target.value })} /></div>
          <div className="form-group"><label className="form-label">LinkedIn (facultatif)</label><input className="form-input" type="url" value={editor.linkedinLink} onChange={(e) => setEditor({ ...editor, linkedinLink: e.target.value })} /></div>
          <button className="btn-save" type="submit">Ajouter l’éditeur</button>
        </form>
        <table className="partners-table"><thead><tr><th>Nom</th><th>Action</th></tr></thead><tbody>{editors.map((item) => <tr key={item.id}><td>{item.name}</td><td><button className="icon-button text-red-600" onClick={() => remove('editor', item.id)}>Supprimer</button></td></tr>)}</tbody></table>
      </div>

      <div className="form-card">
        <form onSubmit={createTechnology} className="project-form">
          <h3>Nouvelle technologie</h3>
          <div className="form-group"><label className="form-label">Nom *</label><input className="form-input" placeholder="Ex. React, NestJS, Flutter" value={technology.name} onChange={(e) => setTechnology({ ...technology, name: e.target.value })} required /></div>
          <div className="form-group"><label className="form-label">Type de projet *</label><select className="form-select" value={technology.type} onChange={(e) => setTechnology({ ...technology, type: e.target.value })}><option>Développement Web</option><option>Développement Mobile</option></select></div>
          <div className="form-group"><label className="form-label">Catégorie *</label><select className="form-select" value={technology.category} onChange={(e) => setTechnology({ ...technology, category: e.target.value })}><option>Frontend</option><option>Backend</option></select></div>
          <button className="btn-save" type="submit">Ajouter la technologie</button>
        </form>
        <table className="partners-table"><thead><tr><th>Nom</th><th>Type</th><th>Catégorie</th><th>Action</th></tr></thead><tbody>{technologies.map((item) => <tr key={item.id}><td>{item.name}</td><td>{item.type}</td><td>{item.category}</td><td><button className="icon-button text-red-600" onClick={() => remove('technology', item.id)}>Supprimer</button></td></tr>)}</tbody></table>
      </div>
    </div>
  );
}
